import { useState } from "react";
import ModalContainer from "../../../Staff/containers/ModalContainer";
import { Controller, useForm } from "react-hook-form";
import { InputField, TextAreaField } from "../../../../CommonElements";
import { Button, Form } from "reactstrap";
import { usePengumuman } from "../../../../Context/PengumumanContext";

const ModalBuatPengumuman = ({ create, data, resetState, toggle, isOpen }) => {
  const pengumumanAPI = usePengumuman();
  const [title] = useState(create ? "Buat Pengumuman" : "Edit Pengumuman");
  const { control, handleSubmit } = useForm({ defaultValues: data });

  const createItem = (data) => {
    pengumumanAPI.createPengumuman(data).then(() => {
      toggle();
      resetState();
    });
  };

  const updateItem = (data) => {
    pengumumanAPI.updatePengumuman(data.id_pengumuman, data).then(() => {
      toggle();
      resetState();
    });
  };

  return (
    <ModalContainer title={title} isOpen={isOpen} toggle={toggle}>
      <Form
        onSubmit={data ? handleSubmit(updateItem) : handleSubmit(createItem)}
      >
        <Controller
          name="title"
          control={control}
          rules={{
            required: "Harap masukkan judul",
          }}
          render={({ field, fieldState }) => (
            <InputField
              label={"Judul"}
              defaultValues={data?.title}
              fieldState={fieldState}
              {...field}
              isRequired={true}
            />
          )}
        />
        <Controller
          name="description"
          control={control}
          rules={{
            required: "Harap masukkan deskripsi",
          }}
          render={({ field, fieldState }) => (
            <TextAreaField
              label={"Deskripsi"}
              defaultValues={data?.description}
              fieldState={fieldState}
              {...field}
              isRequired={true}
            />
          )}
        />
        <Button color="primary">Simpan</Button>
      </Form>
    </ModalContainer>
  );
};

export default ModalBuatPengumuman;
